import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { apiRequest } from 'src/helpers/apiRequest';
import { useAppConfig } from 'src/hooks';
import { ApplicationListResponse } from 'src/types/rest/tenant';

export const useApplicationList = (
  applicationListId?: string,
  options?: Partial<UseQueryOptions<ApplicationListResponse>>,
) => {
  const {
    tenancy: { apiHost },
  } = useAppConfig();

  return useQuery({
    queryFn: () =>
      apiRequest<ApplicationListResponse>({
        url: `${apiHost}/application-lists/${applicationListId}`,
      }),
    queryKey: ['applicationList', applicationListId],
    ...options,
    /**
     * Combined explicitly so a caller-provided `enabled` (e.g. gating on
     * authorization) can't accidentally re-enable the query when there's no
     * id to fetch.
     */
    enabled: !!applicationListId && (options?.enabled ?? true),
  });
};
